module.exports = __webpack_public_path__ + "img/SEGURIFY_landing_icono_003_rapido.142380f5.png";